export interface InventoryItem {
  id: string;
  categoryName: string;
  itemName: string;
  totalQuantity: number;
  inUseQuantity: number;
  availableQuantity: number;
  description?: string;
  unitPrice?: number;
  supplier?: string;
  lastUpdated: string;
}

export interface InventoryCategory {
  id?: string | null;
  categoryName: string;
  totalItems: number;
  totalInUse: number;
  totalAvailable: number;
  items: InventoryItem[];
}

export interface InventorySummary {
  categories: InventoryCategory[];
  totalItems: number;
  totalInUse: number;
  totalAvailable: number;
}

export const INVENTORY_CATEGORIES = [
  "Tyre",
  "Battery",
  "Engine Oil",
  "Brake Pads",
  "Air Filter",
  "Oil Filter",
  "Spark Plugs",
  "Coolant",
  "Brake Fluid",
  "Transmission Oil",
  "Headlight Bulbs",
  "Windshield Wipers",
  "Seat Covers",
  "Floor Mats",
  "Tool Kit",
  "Emergency Kit",
  "First Aid Kit",
  "Fire Extinguisher",
  "Spare Parts",
  "Other",
] as const;

export type InventoryCategoryType = (typeof INVENTORY_CATEGORIES)[number];
